'use strict';
import angular from 'angular';

//todo: rename "show" and "list" to "view"
angular.module('currentUser.services').factory('Role', function () {
    let authorizationsList = [
        'ListClusters',
        'ListOrders',
        'ViewOrder',
        'UpdateOrder',
        'CancelOrder',
        'CopyOrder',
        'ShowOrderAuditHistory',
        'ShowOrderBuySheet',
        'CreateOrderComment',
        'ListOrderComments',
        'DeleteOrderComment',
        'CreateOrderNotification',
        'UpdateOrderSubmitter',
        'ListOrderTasks',
        'ShowOrderTask',
        'CreateOrderTask',
        'ListOrderLineItems',
        'CreateOrderLineItem',
        'ViewLineItem',
        'UpdateLineItem',
        'DeleteLineItem',
        'CancelLineItem',
        'CopyLineItem',
        'ViewFlight',
        'UpdateFlight',
        'DeleteFlight',
        'CancelFlight',
        'CopyFlight',
        'ShowLineItemAuditHistory',
        'ShowLineItemDownloadPdf',
        'UpdateLineItemCampaignManager',
        'CreateLineItemComment',
        'ListLineItemComments',
        'DeleteLineItemComment',
        'ListLineItemTasks',
        'ShowLineItemTask',
        'CreateLineItemTask',
        'DeleteMyTasksComment'
    ];

    class Role {
        constructor() {
            let o = Array.from(arguments).join(',');
            authorizationsList.forEach((authorizationName) => {
                this[`_isAuthorizedTo${authorizationName}`] = o === '*' ? true : o.includes(authorizationName);
            });
        }

        static newFrozenInstance() {
            return Object.freeze(new this(...arguments))
        }

        isAuthorizedToCancelOrder(order) {
            return this._isAuthorizedToCancelOrder && order && order.cancellable
        }

        isAuthorizedToDeleteLineItem(lineItem) {
            return this._isAuthorizedToDeleteLineItem && lineItem && lineItem.deletable
        }
    }

    authorizationsList.forEach(function (authorizationName) {
        let methodName = `isAuthorizedTo${authorizationName}`;
        if (Role.prototype[methodName]) {
            return;
        }
        Role.prototype[methodName] = function () {
            return this[`_${methodName}`]
        }
    });

    return Role
});